var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pot-checker"},[_vm._t("default",_vm._l((_vm.options),function(option,index){return _c('pot-checker-item',{key:index,attrs:{"option":option}})}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }